module.exports = __webpack_public_path__ + "static/shiftclickcolor-a099cd9c12a1dc2b6382f213f4d66ea7.mp4";